export default {
    top_menu: [
        {name:'Əsas şey',    id:0},
        {name:'Şou biznes', id:1},
        {name:'Pişirmə',  id:2},
        {name:'Siyasət',   id:3},
        {name:'+18',  id:4},
        {name:'Cəmiyyət',   id:5},
        {name:'Sağlamlıq',   id:6},
    ],
    read_other: 'Daha çox oxu',
    read_more:  'Daha ətraflı',
    not_found:  'Heç nə tapılmadı',
    read_also:  'Həm də oxuyun',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Bütün hüquqlar qorunur.',
    subscribe: 'Abunə olun',

    thank_order: 'SİFARİŞİNİZ ÜÇÜN TƏŞƏKKÜR EDİRƏM',
    specialist_contact: 'Mütəxəssisimiz tezliklə sizinlə əlaqə saxlayacaq, zəngimizi gözləyin.',
    attention: 'Tərəfdaşlardan endirimlər:',
    hurry: 'Tələsin, endirim aktivləşdirmə müddəti məhduddur! Bu unikal məhsullardan birini seçmək üçün cəmi <span id="time" class="time">30:00</span> dəqiqə vaxtınız var:',

    hour_ago1: "Saat əvvəl",
    hour_ago2: "bir neçə saat əvvəl",
    hour_ago3: "bir neçə saat əvvəl",
    new_publications: "Yeni nəşrlər",
    read: "Oxuyun",
    today_at: "Bu gün",
    author_names: ['Bakhar Nabieva','Elmin Quliyev','Səfael Mişiyev'],
    main_news: "Əsas xəbər",
    leave_already: "Artıq ayrılırsınız? Gözləyin, xəbəri sizin üçün yenilədik",
    already_shared: "artıq paylaşılıb"

}